// extracted by mini-css-extract-plugin
export default {"box":"styles_box__4IcY+","btn":"styles_btn__vhNN9","btnActive":"styles_btnActive__PCfiK","dropdown":"styles_dropdown__ocWIH","dropdownActive":"styles_dropdownActive__c+fsQ"};